









import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'

@Component
export default class TextEllipsis extends Vue {
  @Prop() text!: string

  $refs!: {
    el: HTMLSpanElement
  }

  isEllipsis = false

  mounted() {
    if (this.$refs.el) {
      const el = this.$refs.el
      this.isEllipsis = el.scrollWidth > el.clientWidth
    }
  }
}
